import { render, staticRenderFns } from "./payment_details.vue?vue&type=template&id=679f9a3c&scoped=true&"
import script from "./payment_details.vue?vue&type=script&lang=ts&"
export * from "./payment_details.vue?vue&type=script&lang=ts&"
import style0 from "./payment_details.vue?vue&type=style&index=0&id=679f9a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f9a3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText,VCardTitle})
